// Pure helpers for the driving-school UI. No Phaser/config imports (node --test).

export function formatCooldown(seconds) {
  if (!seconds || seconds <= 0) return '';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return h > 0 ? `za ${h} h ${m} min` : `za ${m} min`;
}

export function nextAttemptLabel(seconds, now = new Date()) {
  const at = new Date(now.getTime() + seconds * 1000);
  const sameDay = at.getFullYear() === now.getFullYear() && at.getMonth() === now.getMonth() && at.getDate() === now.getDate();
  const hh = String(at.getHours()).padStart(2, '0');
  const mm = String(at.getMinutes()).padStart(2, '0');
  return `Następne podejście: ${sameDay ? 'dziś' : 'jutro'} o ${hh}:${mm}`;
}

export function resultHeadline(r) {
  return r.passed
    ? `Zdałeś! ${r.score}/${r.total} {party}`
    : `Nie tym razem: ${r.score}/${r.total} (trzeba ${r.pass_score})`;
}

export function instructorGreeting(d) {
  if (d.has_licence) return 'Gratulacje, masz prawo jazdy! {car}';
  if (!d.course_bought) return 'Cześć! Chcesz zapisać się na kurs prawa jazdy?';
  if (!d.theory_passed) return 'Poucz się teorii, zrób test próbny, a potem egzamin!';
  return 'Teoria zdana! Zostały lekcje praktyczne i egzamin praktyczny.';
}

export function isNear(ax, ay, bx, by, r = 160) {
  return Math.hypot(ax - bx, ay - by) <= r;
}

function practicalLessonsRow(d, cat) {
  const required = cat.lessons_required;
  const done = d.lessons_done || 0;
  if (done >= required) {
    return { key: 'practical_lessons', label: `{car} Lekcje praktyczne {check} ${required}/${required}`, disabled: true, hint: '' };
  }
  const next = d.next_lesson ?? done + 1;
  const enabled = !!d.theory_passed;
  return {
    key: 'practical_lessons',
    label: `{car} Lekcja praktyczna ${next}/${required}`,
    disabled: !enabled,
    hint: enabled ? '' : 'Najpierw zdaj teorię {grad_cap}',
  };
}

function practicalRow(d, cat) {
  const required = cat.lessons_required;
  const done = d.lessons_done || 0;
  const cd = d.practical_cooldown_seconds || 0;
  let hint = '';
  if (d.practical_passed) hint = 'Zdany {check}';
  else if (done < required) hint = 'Najpierw 3 lekcje';
  else if (cd > 0) hint = nextAttemptLabel(cd);
  return {
    key: 'practical',
    label: `{car} Egzamin praktyczny — ${cat.practical_exam_price} zł`,
    disabled: !d.can_take_practical,
    hint,
  };
}

export function menuActions(d, cat) {
  const cd = d.theory_cooldown_seconds || 0;
  return [
    { key: 'course', label: `{note} Zapisz się na kurs — ${cat.course_price} zł`, disabled: !!d.course_bought, hint: '' },
    { key: 'lessons', label: '{book} Lekcje teorii', disabled: !d.course_bought, hint: '' },
    { key: 'practice', label: '{test_tube} Test próbny (za darmo)', disabled: !d.course_bought, hint: '' },
    { key: 'exam', label: `{grad_cap} Egzamin teoretyczny — ${cat.theory_exam_price} zł`,
      disabled: !d.course_bought || !!d.theory_passed || cd > 0,
      hint: d.theory_passed ? 'Zdany {check}' : cd > 0 ? nextAttemptLabel(cd) : '' },
    practicalLessonsRow(d, cat),
    practicalRow(d, cat),
    // Always enabled — the controls card is a plain reference, not gated on progress.
    { key: 'controls', label: 'Jak się jeździ? {gamepad}', disabled: false, hint: '' },
    { key: 'licence', label: '{licence} Moje prawo jazdy', disabled: false, hint: '' },
  ];
}
